import { defineMessages } from "react-intl";

export const messages = defineMessages({
    loadMorePlaylists: {
        id: "sales.general.load-more-playlists",
        defaultMessage: "Load more playlists",
    },
    salesTitle: {
        id: "sales.title",
        defaultMessage: "Trends",
    },
    performanceTitle: {
        id: "sales.title.performance",
        defaultMessage: "Performance",
    },
    infoPopoverTitle: {
        id: "sales.info-popover.title",
        defaultMessage: "Note",
    },
    infoPopover: {
        id: "sales.info-popover.body",
        defaultMessage: `<p>The maximum range you can search on is {days} days.
 If you need data for a larger range, please contact {provider}.</p>
<p>YouTube trends may not be reflective of the final views shown in statements.
 These trends figures should be treated as a guide only.</p>`,
    },
    playlistTrendsTitle: {
        id: "sales.playlist-trends.title",
        defaultMessage: "Playlist trends",
    },
    playlistTrendsTableTotal: {
        id: "sales.playlist-trends.table.total",
        defaultMessage: "Total streams",
    },
    playlistTrendsTableTracks: {
        id: "sales.playlist-trends.table.tracks",
        defaultMessage: "Tracks",
    },
    salesBlurb: {
        id: "sales.blurb",
        defaultMessage: "Currently this data only covers downloads from iTunes " +
            "and streams from Apple Music and Spotify.",
    },
    genderTitle: {
        id: "sales.title.gender",
        defaultMessage: "Gender breakdown",
    },
    ageTitle: {
        id: "sales.title.age",
        defaultMessage: "Age breakdown",
    },
    regionTitle: {
        id: "sales.title.region",
        defaultMessage: "Region breakdown",
    },
    genderSmallprint: {
        id: "sales.small.gender",
        defaultMessage: "Data sourced from Spotify and Apple Music only and may not match the figures above exactly.",
    },
    salesStreams: {
        id: "sales.streams",
        defaultMessage: "Streams",
    },
    salesDownloads: {
        id: "sales.downloads",
        defaultMessage: "Downloads",
    },
    salesTotal: {
        id: "sales.total",
        defaultMessage: "Total",
    },
    numberStreams: {
        id: "sales.num-streams",
        defaultMessage: `{number} {total, plural,
            =0 {streams}
            one {stream}
            other {streams}
        }`,
    },
    numberDownloads: {
        id: "sales.num-downloads",
        defaultMessage: `{number} {total, plural,
            =0 {downloads}
            one {download}
            other {downloads}
        }`,
    },
    totalStreams: {
        id: "sales.total-streams",
        defaultMessage: `Total streams over this period: {number} {total, plural,
            =0 {streams}
            one {stream}
            other {streams}
        }`,
    },
    totalStreamsOfTotal: {
        id: "sales.total-streams-of-total",
        defaultMessage: `Total streams over this period: {number} {total, plural,
            =0 {streams}
            one {stream}
            other {streams}
        } ({percent} of total)`,
    },
    totalStreamsNoValue: {
        id: "sales.total-streams-no-value",
        defaultMessage: "Total streams over this period",
    },
    totalStreamsOverPeriod: {
        id: "sales.total-streams-period",
        defaultMessage: "Total streams over {period}",
    },
    periodTheLastNDays: {
        id: "sales.period.last-n-days",
        defaultMessage: "the last {n} days",
    },
    totalDownloads: {
        id: "sales.total-downloads",
        defaultMessage: `Total downloads over this period: {number} {total, plural,
            =0 {downloads}
            one {download}
            other {downloads}
        }`,
    },
    totalDownloadsOfTotal: {
        id: "sales.total-downloads-of-total",
        defaultMessage: `Total downloads over this period: {number} {total, plural,
            =0 {downloads}
            one {download}
            other {downloads}
        } ({percent} of total)`,
    },
    totalDownloadsNoValue: {
        id: "sales.total-downloads-no-value",
        defaultMessage: `Total downloads over this period`,
    },
    labelCountry: {
        id: "sales.label.country",
        defaultMessage: "Country",
    },
    albumDownloads: {
        id: "sales.graph.album-download",
        defaultMessage: "Album downloads",
    },
    trackDownloads: {
        id: "sales.graph.track-download",
        defaultMessage: "Track downloads",
    },
    itunesAlbumDownloads: {
        id: "sales.graph.itunes-album-download",
        defaultMessage: "iTunes albums",
    },
    itunesTrackDownloads: {
        id: "sales.graph.itunes-track-download",
        defaultMessage: "iTunes tracks",
    },
    trackStreams: {
        id: "sales.graph.track-stream",
        defaultMessage: "Track streams",
    },
    amStreams: {
        id: "sales.graph.am-stream",
        defaultMessage: "Apple Music",
    },
    spotifyStreams: {
        id: "sales.graph.spotify-stream",
        defaultMessage: "Spotify",
    },
    deezerStreams: {
        id: "sales.graph.deezer-stream",
        defaultMessage: "Deezer",
    },
    napsterStreams: {
        id: "sales.graph.napster-stream",
        defaultMessage: "Napster",
    },
    youtubeStreams: {
        id: "sales.graph.youtube-stream",
        defaultMessage: "YouTube",
    },
    youtubeSubscriptionStreams: {
        id: "sales.graph.youtube-subscription-stream",
        defaultMessage: "YouTube Premium",
    },
    youtubeAdStreams: {
        id: "sales.graph.youtube-ad-stream",
        defaultMessage: "YouTube Ad",
    },
    amazonStreams: {
        id: "sales.graph.amazon-stream",
        defaultMessage: "Amazon",
    },
    amazonAlbumDownloads: {
        id: "sales.graph.amazon-album-download",
        defaultMessage: "Amazon albums",
    },
    amazonTrackDownloads: {
        id: "sales.graph.amazon-track-download",
        defaultMessage: "Amazon tracks",
    },
    filterCountries: {
        id: "sales.settings.country-filter",
        defaultMessage: "Filter by country",
    },
    presetLast30Days: {
        id: "sales.presets.last-30-days",
        defaultMessage: "Last 30 days",
    },
    presetThisWeek: {
        id: "sales.presets.this-week",
        defaultMessage: "This week",
    },
    presetLastWeek: {
        id: "sales.presets.last-week",
        defaultMessage: "Last week",
    },
    presetPreviousWeek: {
        id: "sales.presets.previous-week",
        defaultMessage: "Previous week",
    },
    presetThisMonth: {
        id: "sales.presets.this-month",
        defaultMessage: "This month",
    },
    presetLastMonth: {
        id: "sales.presets.last-month",
        defaultMessage: "Last month",
    },
    presetPreviousMonth: {
        id: "sales.presets.previous-month",
        defaultMessage: "Previous month",
    },
    presetLast3Months: {
        id: "sales.presets.last-3-months",
        defaultMessage: "Last 3 months",
    },
    presetPrevious3Months: {
        id: "sales.presets.previous-3-months",
        defaultMessage: "Previous 3 months",
    },
    presetSinceReleaseDate: {
        id: "sales.presets.since-release-date",
        defaultMessage: "Since Release Date",
    },
    genderMale: {
        id: "sales.gender.male",
        defaultMessage: "Male",
    },
    genderFemale: {
        id: "sales.gender.female",
        defaultMessage: "Female",
    },
    genderUnknown: {
        id: "sales.gender.unknown",
        defaultMessage: "Unknown",
    },
    genderNeutral: {
        id: "sales.gender.neutral",
        defaultMessage: "Neutral",
    },
    ageGroupUnknown: {
        id: "sales.age-group.unknown",
        defaultMessage: "Unknown",
    },
    plusAdditionalTracks: {
        id: "sales.plus-additional-tracks",
        defaultMessage: `+ Plus {number, plural,
            =0 {no additional tracks}
            one {# additional track}
            other {# additional tracks}
        }`,
    },
    numStreams: {
        id: "sales.number-streams",
        defaultMessage: "#\xa0streams",
    },
    headlineStatNewReleasesLabel: {
        id: "sales.headline-stats.new-releases",
        defaultMessage: "Streams from new releases",
    },
    headlineStatWholeCatalogueLabel: {
        id: "sales.headline-stats.whole-catalogue",
        defaultMessage: "Streams of whole catalogue",
    },
    headlineStatPlaylistsLabel: {
        id: "sales.headline-stats.playlists",
        defaultMessage: "Streams from playlists",
    },
    headlineStatTrackedPlaylistsLabel: {
        id: "sales.headline-stats.tracked-playlists",
        defaultMessage: "Streams from tracked playlists",
    },
    dspStreamsChartTitle: {
        id: "sales.dsp-streams-chart.title",
        defaultMessage: "Streams by source",
    },
    dspDownloadsChartTitle: {
        id: "sales.dsp-downloads-chart.title",
        defaultMessage: "Downloads by source",
    },
    geoChartTitle: {
        id: "sales.geo-chart.title",
        defaultMessage: "Performance by country",
    },
});
